import { InputLabel as BaseInputLabel, Typography, styled } from '@mui/material'

const PREFIX = 'RadioField'
export const classes = {
  inputRoot: `${PREFIX}-inputRoot`,
  inputChecked: `${PREFIX}-inputChecked`,
  label: `${PREFIX}-label`,
  error: `${PREFIX}-error`,
}

export const InputLabel = styled(BaseInputLabel)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}))

export const ErrorWrapper = styled(Typography)(({ theme }) => ({
  marginTop: 3,
  width: '100%',
  color: theme.palette.error.main,
  fontSize: '0.75rem',
}))
